<app-summary-field *ngIf="entity" [value]="entity.label" iconName="tag"></app-summary-field>